import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from 'sonner';
import LoginPage from '@/pages/LoginPage';
import StaffLoginPage from '@/pages/StaffLoginPage';
import ChatPage from '@/pages/ChatPage';
import AdminPortal from '@/pages/AdminPortal';
import AgentPortal from '@/pages/AgentPortal';
import LawyerPortal from '@/pages/LawyerPortal';
import AuthCallback from '@/pages/AuthCallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/staff" element={<StaffLoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Client Chat - accessible with or without auth */}
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/" element={<ChatPage />} />

          {/* Staff Portals - protected */}
          <Route path="/admin/*" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPortal />
            </ProtectedRoute>
          } />
          <Route path="/agent/*" element={
            <ProtectedRoute allowedRoles={['agent', 'admin']}>
              <AgentPortal />
            </ProtectedRoute>
          } />
          <Route path="/lawyer/*" element={
            <ProtectedRoute allowedRoles={['lawyer', 'admin']}>
              <LawyerPortal />
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster position="top-right" richColors />
      </Router>
    </AuthProvider>
  );
}

export default App;
